import type { CollectionPickerField, CollectionRef } from '@aquilixshop/ui-react';
import { FieldRow } from '../FieldRow';
import { EntityPickerListbox } from './EntityPickerListbox';
import { collectionPickerSource } from '../../lib/collectionsApi';
import { bt } from '../../i18n';

/**
 * Collection picker (feature 0023 P1) — the seller picks a REAL collection for a section that references
 * one (`featured-collection`, `collection-list` selected, `collage`). Replaces the M4 stub with a
 * searchable listbox over `GET /api/collections` (ACTIVE only). The stored value is the final
 * `{ kind:'collection', id }` {@link CollectionRef} (no migration); "None" clears it. Commits immediately.
 */
export function CollectionControl({
  field,
  value,
  onChange,
}: {
  field: CollectionPickerField;
  value: CollectionRef | undefined;
  onChange: (next: CollectionRef | undefined) => void;
}) {
  return (
    <FieldRow id={field.id} label={field.label} info={field.info} labelAs="span" layout="row">
      <EntityPickerListbox
        value={value?.id}
        onSelect={(id) => onChange(id ? { kind: 'collection', id } : undefined)}
        source={collectionPickerSource}
        label={field.label}
        noneLabel={bt('chrome.common.none', 'None')}
        searchPlaceholder={bt('chrome.link.search_collections', 'Search collections…')}
        emptyLabel={bt('chrome.link.no_collections', 'No collections found.')}
        errorLabel={bt('chrome.link.collections_failed', 'Couldn’t load collections.')}
      />
    </FieldRow>
  );
}
